import React from 'react';
import PropTypes from 'prop-types';
import { useMediaContext } from './context';

const withMedia = (WrappedComponent) => {
  const Wrapper = ({ wrappedComponentRef, ...rest }) => {
    const { media } = useMediaContext();
    return <WrappedComponent {...rest} ref={wrappedComponentRef} media={media} />;
  };

  Wrapper.propTypes = {
    wrappedComponentRef: PropTypes.func,
  };

  Wrapper.defaultProps = {
    wrappedComponentRef: undefined,
  };

  return Wrapper;
};

export default withMedia;
